import { createFileRoute } from '@tanstack/react-router'
import { useSession } from '../auth/useSession'
import { isSafeReturnPath } from '../auth/returnRoute'
import { Button } from '../ui/Button'
import { StatePage } from '../ui/states'

export function AuthError() {
  const session = useSession()
  const params = new URLSearchParams(window.location.search)
  const code = params.get('code')
  const destination = params.get('return_to')
  const unavailable = code === 'provider_unavailable'
  return (
    <StatePage illustration={code === 'login_cancelled' ? false : 'connection'} alert>
      <h1 className="font-heading text-2xl font-semibold">
        {unavailable
          ? 'The sign-in service is not available'
          : code === 'login_cancelled'
            ? 'Sign-in was cancelled'
            : 'Sign-in did not complete'}
      </h1>
      <Button onClick={() => session.signIn(isSafeReturnPath(destination) ? destination : '/')}>
        Sign in again
      </Button>
    </StatePage>
  )
}
export const Route = createFileRoute('/auth/error')({ component: AuthError })
